<ion-item>
  <ion-toggle [checked]="item.getVisible()" (ionChange)="onChange($event)" color="success">
    {{ item.get('name') | translate }}
  </ion-toggle>
</ion-item>
